import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  HostListener,
} from '@angular/core';
import { Tools } from 'linkurious-shared';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lk-context-bubble',
  template: `<div class="bubble__wrapper" #wrapper [ngClass]="type">
  <button class="bubble__trigger">
    <icon [name]="type" size="15"></icon>
  </button>
  <span class="bubble__title">{{title}}</span>
  <div class="bubble__element" #bubble [style.top]="top" [style.left]="left" [@openState]="bubbleOpened">
    <div class="bubble">
      <div class="bubble__content">
        <div class="bubble__media">
          <icon [name]="type" size="24"></icon>
        </div>
        <ng-content select="bubble-body"></ng-content>

      </div>
      <ng-content select="bubble-link"></ng-content>
    </div>
  </div>
</div>


`,
  styles: [`.bubble__wrapper{cursor:pointer;display:inline-flex;align-items:center;line-height:1;position:relative;width:100%}.bubble__wrapper .bubble__trigger{flex:0 0 auto;width:25px;height:25px;padding:0;align-items:center;justify-content:space-around;border-radius:50%;cursor:pointer;margin-right:5px;background:#fff;border:1px solid #cbcbcb;color:#000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0}.bubble__wrapper.error{color:#d80000}.bubble__wrapper.error .bubble__trigger{background:#f55564;border-color:#f55564;color:#fff}.bubble__wrapper .bubble__title{flex:1;font-size:12px}.bubble__element{z-index:9999;position:fixed;padding-bottom:30px;visibility:hidden}.bubble{width:350px;padding:15px 20px;border:1px solid #cbcbcb;background:#fff;position:relative;box-shadow:0 6px 12px rgba(0,0,0,.175);-o-box-shadow:0 6px 12px rgba(0,0,0,.175);-ms-box-shadow:0 6px 12px rgba(0,0,0,.175);-moz-box-shadow:0 6px 12px rgba(0,0,0,.175);-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175)}.bubble:after{content:'';width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-top:10px solid #fff;position:absolute;bottom:-10px;left:176px}.bubble:before{content:'';width:0;height:0;border-left:12px solid transparent;border-right:12px solid transparent;border-top:12px solid #cbcbcb;position:absolute;bottom:-12px;left:174px}.bubble .bubble__media{flex:0 0 30px;height:30px;display:flex;align-items:center;justify-content:space-around;border-radius:50%;background:#cbcbcb;color:#fff;margin-right:20px}.bubble .bubble__content{display:flex;align-items:center;line-height:20px}.bubble bubble__link{display:block;height:40px}.error .bubble{border-color:#d80000}.error .bubble:before{border-top-color:#d80000}.error .bubble .bubble__media{background:#f55564}`],
  animations: [
    trigger('openState', [
      state('false', style({ opacity: 0, visibility: 'hidden' })),
      state('true', style({ opacity: 1, visibility: 'visible' })),
      transition('* => *', animate('300ms ease-in-out'))
    ])
  ],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class ContextBubbleComponent {

  @Input() public type: 'info'|'error'|'help';
  @Input() public title: string;
  @Input() public event: 'mouseover'|'click' = 'click';
  @ViewChild('bubble') private _bubble;
  @ViewChild('wrapper') private _wrapper;
  public bubbleOpened: boolean = false;
  public top: string;
  public left: string;

  @HostListener('document:click', ['$event'])
  onClick(e: MouseEvent): void {
    if ( this.event === 'click' ) {
      this.toggleBubble(e);
    }
  }

  @HostListener('mouseover', ['$event'])
  onHover(e: MouseEvent): void {
    if ( this.event === 'mouseover' ) {
      this.setPosition();
      this.bubbleOpened = true;
    }
  }

  @HostListener('mouseleave', ['$event'])
  onLeave(e: MouseEvent): void {
    if ( this.event === 'mouseover' ) {
      this.bubbleOpened = false;
    }
  }

  /**
   * Open / close the bubble
   */
  private toggleBubble(e: MouseEvent) {
    if ( this.bubbleOpened ) {
      this.bubbleOpened = false;
    } else if ( this._wrapper.nativeElement.contains(e.target) ) {
      this.setPosition();
      this.bubbleOpened = true;
    }
  }

  /**
   * set the position of the bubble
   */
  private setPosition() {
    this.top = Tools.numberToPixels(
      this._wrapper.nativeElement.getBoundingClientRect().top - this._bubble.nativeElement.getBoundingClientRect().height + 10
    );
    this.left = Tools.numberToPixels(
      this._wrapper.nativeElement.getBoundingClientRect().left - ( this._bubble.nativeElement.getBoundingClientRect().width / 2) + 20
    );
  }
}
